import { useEffect, useState } from 'react'

const getLocalStorageValue = <
  T extends string | number | object | null | boolean | undefined,
>(
  key: string,
  defaultValue: T,
) => {
  try {
    return JSON.parse(localStorage.getItem(key) ?? JSON.stringify(defaultValue))
  } catch {
    return defaultValue
  }
}

export const useLocalStorage = <
  T extends string | number | object | null | boolean | undefined,
>(
  key: string,
  defaultValue: T,
) => {
  const [value, setValue] = useState<T>(getLocalStorageValue(key, defaultValue))

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value))
  }, [key, value])

  return [value, setValue] as const
}
